// src/lib/hashtag.ts
export function hashtagToSlug(raw: string): string {
    return raw
        .replace(/^#/, "")
        .trim()
        .replace(/\s+/g, "_")
        .replace(/_+/g, "_");
}

export function hashtagToHref(
    raw: string,
    hrefPrefix = "/timeline",
): string {
    const slug = hashtagToSlug(raw);
    return `${hrefPrefix}?tag=${encodeURIComponent(slug)}`;
}